/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import {FourSocials} from '../components/layouts/TwoColumns';
import CuriconHeader from '../components/layouts/CuriConHeader';
import AmandaFox from '../assets/images/amandafox.png';
import Jens from '../assets/images/jens.png';
import Eirik from '../assets/images/eirik.png';
import Eskild from '../assets/images/eskild.png';
import TeamPhoto from '../assets/images/curicon2023.png';
import Image from 'next/image';
export const meta = {
  author: 'Jens Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  customHeader: _jsx(CuriconHeader, {}),
  disableHeadline: true,
  mdx: true,
  meta: meta,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What is Curicon?"
      }), "\n", _jsx(_components.p, {
        children: "Curicon is an innovative and transformative educational conference hosted by Curipod, a leading company at the forefront of harnessing the power of Artificial Intelligence (AI) to revolutionize the field of education. This week-long event brings together forward-thinking educators, AI experts, and thought leaders to explore cutting-edge topics ranging from student agency and accessibility to subject-specific applications and AI-driven pedagogical approaches. Curicon serves as a platform for educators to discover, discuss, and collaborate on how AI can empower teachers and students, making learning more engaging, inclusive, and effective."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "When is Curicon?"
      }), "\n", _jsx(_components.p, {
        children: "Curicon is scheduled to take place virtually October 23-27, 5:00PM-8:00 PM daily. It will be live streamed to our Curipod Community Facebook group, X, Youtube channel, and LinkedIn page. You can join in by following any of the social channel links below!"
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(FourSocials, {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "What types of presentations can I expect?"
      }), "\n", _jsx(_components.p, {
        children: "Whether you're interested in enhancing student agency, improving accessibility, delving into subject-specific AI solutions, or exploring innovative pedagogical approaches, Curicon presentations offer a rich tapestry of insights and strategies that cater to a wide spectrum of interests and expertise levels."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "Why should I register?"
      }), "\n", _jsx(_components.p, {
        children: "When you register for the event you will get event reminders leading up to the week of Curicon. After Curicon you will receive a conference guide with links to all of the session replays. You will also get a certificate of attendance and a special email badge following the conclusion of the event to go towards PLC hours"
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "The event is live, but will I be able to access links to the replay?"
      }), "\n", _jsx(_components.p, {
        children: "As a registered attendee, you'll receive email access to the replays of all the sessions and presentations. This means you can catch up on the valuable content, insights, and innovations discussed at your own pace, whenever it suits your schedule. Don't miss out on this opportunity to explore the intersection of AI and education, even if you can't be there in real-time. Register today and embark on your Curicon journey whenever you're ready."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {})]
    });
  }
}
export default MDXContent;
